// Save controls: export the action log (the save IS the log), import, wipe.

import { useRef } from 'react';

export function SaveControls({
  onExport,
  onImport,
  onWipe,
}: {
  onExport: () => void;
  onImport: (file: File) => void;
  onWipe: () => void;
}) {
  const fileRef = useRef<HTMLInputElement>(null);
  return (
    <div className="save-controls" aria-label="Save controls">
      <button onClick={onExport}>Export save</button>
      <button onClick={() => fileRef.current?.click()}>Import save</button>
      <input
        ref={fileRef}
        type="file"
        accept="application/json"
        hidden
        onChange={(e) => {
          const f = e.target.files?.[0];
          if (f) onImport(f);
          e.target.value = '';
        }}
      />
      <button className="danger" onClick={onWipe}>
        Wipe
      </button>
    </div>
  );
}
